/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAuthorFragment} from '@amblique/contentful/app/contentful/fragments/author/base-author.fragment';

export const AuthorFragment = gql`
  ${BaseAuthorFragment}

  fragment AuthorFragment on Author {
    ...BaseAuthorFragment
  }
`;
